export default [
  { from: 'SEO', to: 'Direct', value: '3837', id:'A1' },
  { from: 'Direct', to: 'Purchase', value: '3837', id:'A1' },

  { from: 'Direct', to: 'Purchase', value: '3233', id:'A2' },

  { from: 'Direct', to: 'Purchase', value: '2394', id:'A3' },

  { from: 'Direct', to: 'Purchase', value: '1801', id:'A5' },
  
  { from: 'SEO', to: 'Direct', value: '2233', id:'A4' },
  { from: 'Direct', to: 'Purchase', value: '2233', id:'A4' },

  { from: 'Direct ', to: 'SEO', value: '1789', id:'A6' },
  { from: 'SEO', to: 'Purchase ', value: '1789', id:'A6' },

  { from: 'SEO', to: 'Direct', value: '1135', id:'A7' },
  { from: 'Direct', to: 'Purchase', value: '1135', id:'A7' },

  { from: 'SEO', to: 'Direct', value: '827', id:'A8' },
  { from: 'Direct', to: 'Purchase', value: '827', id:'A8' },

  { from: 'Direct ', to: 'SEO', value: '740', id:'A9' },
  { from: 'SEO', to: 'Purchase ', value: '740', id:'A9' },


  { from: 'Camp(impression)', to: 'SEO', value: '740', id:'A0' },
  { from: 'SEO', to: 'Purchase ', value: '740', id:'A0' },
  
  { from: 'Direct ', to: 'Campanas', value: '580', id:'B3' },
  { from: 'Campanas', to: 'Purchase ', value: '580', id:'B3' },
  
  { from: 'Campanas', to: 'SEO', value: '555', id:'B4' },
  { from: 'SEO', to: 'Purchase ', value: '555', id:'B4' },
  
  { from: 'Campanas', to: 'Social Media', value: '740', id:'B2' },
  { from: 'Social Media', to: 'Purchase ', value: '740', id:'B2' },

  { from: 'Direct ', to: 'SEO', value: '740', id:'B1' },
  { from: 'SEO', to: 'Direct', value: '827', id:'B1' },
  { from: 'Direct', to: 'Purchase', value: '827', id:'B1' },

  { from: 'Camp(impression)', to: 'SEO', value: '518', id:'B5' },
  { from: 'SEO', to: 'Purchase ', value: '518', id:'B5' },

  { from: 'Camp(impression)', to: 'Direct', value: '457', id:'B6' },
  { from: 'Direct', to: 'Purchase', value: '457', id:'B6' },

  { from: 'Direct ', to: 'SEO', value: '444', id:'B7' },
  { from: 'SEO', to: 'Direct', value: '444', id:'B7' },
  { from: 'Direct', to: 'Purchase', value: '444', id:'B7' },

  { from: 'Camp(impression)', to: 'SEO', value: '395', id:'B8' },
  { from: 'SEO', to: 'Direct', value: '395', id:'B8' },
  { from: 'Direct', to: 'Purchase', value: '395', id:'B8' },

  { from: 'Campanas', to: 'SEO', value: '259', id:'B9' },
  { from: 'SEO', to: 'Direct', value: '259', id:'B9' },
  { from: 'Direct', to: 'Purchase', value: '259', id:'B9' },

  { from: 'Direct ', to: 'Campanas', value: '259', id:'B0' },
  { from: 'Campanas', to: 'Purchase ', value: '259', id:'B0' },

  { from: 'Direct ', to: 'Camp(impression)', value: '160', id:'C1' },
  { from: 'Camp(impression)', to: 'Direct', value: '160', id:'C1' },
  { from: 'Direct', to: 'Purchase', value: '160', id:'C1' },

  { from: 'SEO ', to: 'Direct ', value: '136', id:'C2' },
  { from: 'Direct ', to: 'Campanas', value: '136', id:'C2' },
  { from: 'Campanas', to: 'SEO', value: '136', id:'C2' },
  { from: 'SEO', to: 'Purchase ', value: '136', id:'C2' },

  { from: 'SEO', to: 'Referal', value: '123', id:'C3' },
  { from: 'Referal', to: 'Purchase', value: '123', id:'C3' },

];
